import type { Dayjs } from 'dayjs'

import useUser from '@/legacy-src/hooks/useUser'
import { dayjs } from '@/legacy-src/lib/dayjs/day'
import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import type { ClientBookingSubscriptionStatusMessageProps } from '@/src/domains/client-booking/components/ClientBookingSubscriptionStatus/ClientBookingSubscriptionStatusMessage'
import { useGetUserSubscription } from '@/src/domains/subscription/hooks/useGetUserSubscription'
import { getIsCoveredBySubscription } from '@/src/domains/subscription/utils/getIsCoveredBySubscription'
import { resolveSubscriptionUsageForMonth } from '@/src/domains/subscription/utils/resolveSubscriptionUsageForMonth'

interface UseClientBookingSubscriptionStatusRedesignedParams {
  month: Dayjs
  therapist: TherapistType
  service: ServiceType
}

export const useClientBookingSubscriptionStatusRedesigned = ({
  month,
  therapist,
  service,
}: UseClientBookingSubscriptionStatusRedesignedParams): ClientBookingSubscriptionStatusMessageProps | null => {
  const { isClient } = useUser()

  const { data } = useGetUserSubscription({
    suspense: true,
    readyToFetch: isClient,
  })

  if (data === undefined) {
    return null
  }

  const usage = resolveSubscriptionUsageForMonth(data, month)

  if (!data.subscription || !usage) {
    return null
  }

  const { subscription } = data

  if (month.isBefore(dayjs(subscription.validFromMonth), 'month')) {
    return null
  }

  if (!getIsCoveredBySubscription({ subscription, therapist, service })) {
    return null
  }

  return { month: month.format('MMMM'), freeEventsLeft: usage.available }
}
